import '@src/slide/infrastructure/module/dependent/report/log/weblog-default';
import React, { Component } from 'react';
import { getQuery } from 'sutils';
import Manager from '../../common/manager';
import './index.less';
import { checkClientVars } from '../../common/check-client-vars';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { DOUBLE_TOOLBAR_HEIGHT, SINGLE_TOOLBAR_HEIGHT } from '@src/framework/editor/src/js/constants';

const SINGLE_MODE = '1';
const DOUBLE_MODE = '2';
const TITLE_BAR_HEIGHT = 40;

class Wrapper extends Component {
    public constructor(props) {
        super(props);
        checkClientVars();
    }

    public componentDidMount() {
        let toolbarMode;
        if (window.basicClientVars?.userInfo?.settings?.toolbarMode) {
            ({ toolbarMode } = window.basicClientVars.userInfo.settings);
        } else {
            toolbarMode = userLocalStorage.getItem(
                LocalStorageKeys.TOOLBAR_MODE_SLIDE,
                DOUBLE_MODE,
            );
        }
        this.controlPages(toolbarMode);
    }

    public render() {
        return (
            <Manager />
        );
    }

    private controlPages(toolbarMode) {
        const container = document.querySelector('#pages') as HTMLElement;

        if (container) {
            const toolBarHeight = this.getToolBarHeight(toolbarMode);
            const titleBarHeight = this.getTitleBarHeight();
            let containerTop = titleBarHeight + toolBarHeight;

            // cac 有和下述 query 相同效果的配置
            if (getQuery('hideTitlebar')) {
                containerTop -= titleBarHeight;
            }
            if (getQuery('hideToolbar')) {
                containerTop -= toolBarHeight;
            }
            container.style.top = `${containerTop}px`;
            container.style.height = `calc(100% - ${containerTop}px)`;
        }
    }

    private getToolBarHeight(toolbarMode: typeof SINGLE_MODE | typeof DOUBLE_MODE) {
        if (appConfigInstance.getConfig('toolbar') ?? true) {
            return toolbarMode === SINGLE_MODE ? SINGLE_TOOLBAR_HEIGHT : DOUBLE_TOOLBAR_HEIGHT;
        }
        return 0;
    }

    private getTitleBarHeight() {
        if (appConfigInstance.getConfig('titlebar') ?? true) {
            return TITLE_BAR_HEIGHT;
        }
        return 0;
    }
}

export default Wrapper;
